export const getActiveAnnouncement = (state: any) => state?.announcement?.activeAnnouncement;
export const getExpiredAnnouncements = (state: any) => state?.announcement?.expiredAnnouncements;
export const getShowAnnouncement = (state: any) => state?.announcement?.showAnnouncement;
export const getAnnouncementLoader = (state: any) => state?.announcement?.loading;
